export const customerURL = "https://customer.catalogyapp.com";
